import { render, staticRenderFns } from "./TaskSetItem.vue?vue&type=template&id=0f160601&scoped=true&"
import script from "./TaskSetItem.vue?vue&type=script&lang=js&"
export * from "./TaskSetItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskSetItem.vue?vue&type=style&index=0&id=0f160601&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f160601",
  null
  
)

export default component.exports